import React from 'react';
import StarIcon from '@mui/icons-material/Star';
import StarOutlineOutlinedIcon from '@mui/icons-material/StarOutlineOutlined';
import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

interface FavoriteIcon {
  isFavorite?: boolean;
  size?: number;
}

const styles = {
  favorite: css`
    color: ${colors.orange800} !important;
    cursor: pointer;
  `,
  default: css`
    color: ${colors.prussian} !important;
    cursor: pointer;
  `,
};

export const FavoriteIcon: React.FC<FavoriteIcon> = ({ isFavorite = true, size = 30 }) =>
  isFavorite ? (
    <StarIcon sx={{ fontSize: pxToRem(size) }} className={styles.favorite} />
  ) : (
    <StarOutlineOutlinedIcon sx={{ fontSize: pxToRem(size) }} className={styles.default} />
  );
